import { Component, OnInit, Input } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';
import { SearchService } from '../../../services/search.service';
import { NotifierService } from 'angular-notifier';
@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.css']
})
export class ReviewsComponent implements OnInit {
  private readonly notifier: NotifierService;
  constructor(private homepageService: HomepageService, private searchService: SearchService, notifierService: NotifierService) {
     this.notifier = notifierService;
   }
  reviews: any =  [];
  @Input() buId: number;
  isCard: boolean =  false;
  ngOnInit() {
  		this.getReview();
  }
 
 slideConfig = {
    "slidesToShow": 1,
    'autoplay': true,
    'autoplaySpeed': 4000,
    'fade' : true,
    'dots': true,
    'vertical' : false,
    'prevArrow' : '<button class="slickArrowpre slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-chevron-left"></i></button>',
    'nextArrow' : '<button class="slickArrownxt slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-chevron-right"></i></button>'
  }

    getReview() {
  	 let getwidgetsSettingDataSave =  this.homepageService.getwidgetsSettingDataSave();
     getwidgetsSettingDataSave.data.forEach(evt => {
            if(evt.code == 'RV' && this.buId  == evt.id){
              this.reviews = evt.content;                         
              if(evt.settings.view == 'C'){
                this.isCard = true;
               } else {
                this.isCard = false;
               }
            }            
          }); 
    }

    slickInit(e) {
      // console.log('slick initialized');
    }
   

  imageError(event,images){
    if(typeof($('body').find('span.RV').find('img[custom="'+event+'"]').attr('index')) != 'undefined' &&  parseInt($('body').find('span.RV').find('img[custom="'+event+'"]').attr('index')) > 0 ){
      var index:number = parseInt($('body').find('span.RV').find('img[custom="'+event+'"]').attr('index'));
      if(typeof($('body').find('span.RV').find('img[custom="'+event+'"]').attr('loaded')) != 'undefined')
      index--;
      this.imageLoad(event, images,index, true);
    } else {
      $('body').find('span.RV').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('span.RV').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('span.RV').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
      $('body').find('span.RV').find('img[custom="'+event+'"]').remove();  
      $('body').find('#'+event).remove();        
    }
  }
  
  imageLoad(event, images, index, fromError = false) {
    if($('body').find('span.RV').find('img[custom="'+event+'"]').attr('loaded') == 'yes' && !fromError) {
      return false;
    }
    if($('body').find('#'+event).length <= 0) {
       $('body').append('<img id="'+event+'" src="" style="display:none;">');
    }
    var $this = this;
    var imagesAll = this.searchService.sortedImage(images);
    $('#'+event).attr('src',imagesAll[index]);
    setTimeout(function(){
      var tempWidth = $('#'+event).width();
      //console.log(tempWidth, event, index);
      var temp = document.getElementById(event);
      if(tempWidth <= 1 && index > 0){
        $this.imageLoad(event,images,index-1, true);
        return false;
      }else if(tempWidth <= 1 && index == 0){
        $('body').find('span.RV').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('span.RV').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('span.RV').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
        $('body').find('span.RV').find('img[custom="'+event+'"]').remove();
      }
    },500);
    if(typeof(imagesAll[index]) != 'undefined') {
      $('body').find('span.RV').find('img[custom="'+event+'"]').attr('src',imagesAll[index]);
      $('body').find('span.RV').find('img[custom="'+event+'"]').attr('loaded','yes');        
      $('body').find('span.RV').find('img[custom="'+event+'"]').attr('index',index);        
    }
  }
   
}
